// src/pages/AgreementPage.tsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import "./AgreementPage.css";
import { useAgreementMutation } from "../store/api/authApi";

const AgreementPage = () => {
    const [agreed, setAgreed] = useState(false);
    const navigate = useNavigate();
    const [agreement] = useAgreementMutation();

    const handleAgree = () => {
        localStorage.setItem("user_agreement", "true");
        agreement({
            agree: 1,
        });
        navigate("/personal-info");
    };

    return (
        <div className="agreement-container">
            <h1>Пользовательское соглашение</h1>

            <div className="agreement-content">
                <p>
                    Настоящее Пользовательское соглашение (далее – «Соглашение») является
                    юридически обязывающим договором между ОсОО «ОНЭКС КЕЙДЖИ»
                    (ИНН 00108202310490), осуществляющим деятельность под фирменным
                    наименованием «Onza.kg» (далее – «Onza.kg», «Исполнитель»), и Вами,
                    физическим лицом, являющимся пользователем сайта или мобильного
                    приложения Onza.kg (далее – «Пользователь»).
                </p>

                <h3>1. Международная перевозка посылок</h3>
                <p>
                    Onza.kg предоставляет Пользователю услуги по международной перевозке
                    посылок, заказанных Пользователем на зарубежных сайтах, с зарубежных
                    складов Onza.kg до территории Кыргызской Республики, а именно до
                    пунктов, указанных в разделе «Контакты» Сайта/Приложения Onza.kg,
                    либо до указанной Пользователем точки доставки в г. Бишкек.
                </p>
                <p>
                    Пользователь обязуется корректно указывать адреса зарубежных складов
                    Onza.kg при оформлении заказов на зарубежных сайтах и оплачивать
                    услуги международной перевозки до получения посылки согласно
                    действующим тарифам Onza.kg.
                </p>

                <h3>2. Персональные данные и конфиденциальность</h3>
                <p>
                    Персональная информация, предоставляемая Пользователем при регистрации
                    на Сайте/Приложении Onza.kg (фамилия, имя, отчество, паспортные данные,
                    адрес проживания, телефон, ИНН и иные данные), является
                    конфиденциальной.
                </p>
                <p>
                    Указанная информация предоставляется исключительно с целью обеспечения
                    выполнения требований таможенного законодательства Кыргызской
                    Республики и может передаваться в таможенные органы в необходимом
                    объёме. Onza.kg обязуется обеспечивать сохранность персональных данных
                    Пользователя и не разглашать их третьим лицам в иных целях.
                </p>

                <h3>3. Достоверность данных</h3>
                <p>
                    Пользователь обязуется предоставлять достоверные и актуальные сведения
                    при регистрации и использовании Сайта/Приложения, а также сведения о
                    совершенных заказах для целей таможенного оформления.
                </p>
                <ul>
                    <li>корректные персональные данные;</li>
                    <li>достоверную информацию о заказах.</li>
                </ul>
                <p>
                    В случае изменения предоставленных данных Пользователь обязан
                    своевременно уведомить Onza.kg. Onza.kg не несёт ответственности за
                    последствия, вызванные предоставлением недостоверных или неполных
                    сведений.
                </p>

                <h3>4. Принятие условий Соглашения</h3>
                <p>
                    Нажимая кнопку «Принять», Пользователь подтверждает согласие со всеми
                    условиями настоящего Соглашения и даёт согласие на обработку своих
                    персональных данных.
                </p>

                {/* 🔥 НОВЫЙ ПУНКТ */}
                <h3>5. Удаление персональных данных</h3>
                <p>
                    Пользователь имеет право в любое время запросить удаление своих
                    персональных данных, предоставленных при регистрации и использовании
                    Сайта/Приложения Onza.kg.
                </p>
                <p>
                    Для удаления персональных данных Пользователю необходимо обратиться
                    к менеджеру Onza.kg через мессенджер WhatsApp по официальному номеру,
                    указанному в разделе «Контакты» Сайта/Приложения.
                </p>
                <p>
                    После получения запроса менеджером Onza.kg персональные данные
                    Пользователя будут удалены в течение{" "}
                    <strong>24 (двадцати четырёх) часов</strong>, за исключением данных,
                    подлежащих обязательному хранению в соответствии с требованиями
                    законодательства Кыргызской Республики.
                </p>

                <div className="agreement-checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={agreed}
                            onChange={(e) => setAgreed(e.target.checked)}
                        />
                        Я ознакомился и принимаю условия Пользовательского соглашения и
                        согласен на обработку моих персональных данных.
                    </label>
                </div>

                <Button
                    disabled={!agreed}
                    onClick={handleAgree}
                    style={{
                        backgroundColor: "#103d64",
                        color: "white",
                        width: "100%",
                        marginTop: 20,
                    }}
                >
                    Принять
                </Button>
            </div>
        </div>
    );
};

export default AgreementPage;
